/*
  - This service is responsible for auto logout after a particular time
  - Commented by Sarthak on Feb 20, 2024
*/
import { Router } from '@angular/router';
import { Injectable, NgZone } from '@angular/core';
import * as store from 'store2';
import { ChangeUsersService } from '../services/change-users.service';
/*
  - Auto logout after 24 hrs 
  - Commented by Sarthak on Feb 20, 2024
*/
const MINUTES_UNITL_AUTO_LOGOUT = 1440 // in Minutes
const CHECK_INTERVALL = 1000 // in ms
const STORE_KEY = 'lastAction';

@Injectable({
  providedIn: 'root'
})
export class AutoLogoutServiceService {
  /*
    - Router for routing user to login page when time expires
    - NgZone to detect changes 
    - ChangeUser service is imported to call specific service function saved there
    - Commented by Sarthak on Feb 20, 2024
  */
  constructor(
    private router: Router,
    private ngZone: NgZone,
    private changeService:ChangeUsersService
  ) {
    this.check();
    this.initListener();
    this.initInterval();
  }
  /*
    - these are getter and setter function get and set STORE_KEY value
    - Commented by sarthak on Feb 20, 2024
  */
  get lastAction() {
    return parseInt(store.default.get(STORE_KEY));
  }
  set lastAction(value) {
    store.default.set(STORE_KEY, value);
  }
  /*
    - Initializes an event listener on the document body to detect user activity (click events).
    - When a click event occurs, it calls the reset() function to update the last action timestamp.
    - Commented by Sarthak on Feb 20, 2024
  */
  initListener() {
    this.ngZone.runOutsideAngular(() => {
      document.body.addEventListener('click', () => this.reset());
    });
  }
  /*
    - Initializes an interval to periodically check user activity.
    - Calls the check() function at the specified interval.
    - Commented by Sarthak on Feb 20, 2024
  */
  initInterval() {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.check();
      }, CHECK_INTERVALL);
    })
  }
  /*
    - Updates the last action timestamp to the current time whenever user activity is detected.
    - Commented by Sarthak on Feb 20, 2024
  */
  reset() {
    this.lastAction = Date.now();
  }
  /*
    - This function checks if time is left until auto logout or not 
    - If time is expired user is navigated to login page 
    - Commented by Sarthak on Feb 20, 2024
  */
  check() {
    const now = Date.now();
    const timeleft = this.lastAction + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;
    this.ngZone.run(() => {
      if (isTimeout && (localStorage.getItem("loginStatus")=== 'yes')) {
        localStorage.clear();
        this.router.navigate(['login']);
        this.changeService.logout();
      }
    });
  }
}